import { render, staticRenderFns } from "./GenerateReportPageTable.vue?vue&type=template&id=66f6f96a&scoped=true"
import script from "./GenerateReportPageTable.vue?vue&type=script&lang=js"
export * from "./GenerateReportPageTable.vue?vue&type=script&lang=js"
import style0 from "./GenerateReportPageTable.vue?vue&type=style&index=0&id=66f6f96a&prod&scoped=true&lang=scss"
import style1 from "./GenerateReportPageTable.vue?vue&type=style&index=1&id=66f6f96a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f6f96a",
  null
  
)

export default component.exports